import script from "./BaseSwitch.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseSwitch.vue?vue&type=script&setup=true&lang=ts"

import "./BaseSwitch.vue?vue&type=style&index=0&id=39912e80&lang=css"

const __exports__ = script;

export default __exports__